var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._b({staticClass:"quill-viewer ql-editor",domProps:{"innerHTML":_vm._s(_vm.cContent)}},'div',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }